import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { MailService } from 'src/app/services/mail.service';
import { DialogCommonError } from '../../dialogs-errors/dialog-common-error.component';
import { MatDialog } from '@angular/material';

@Component({
    selector: 'app-dossier-delegation-init',
    templateUrl: './delegation-init.component.html',
    styleUrls: ['./delegation-init.component.scss']
})
export class DossierDelegationInitComponent implements OnInit {

    @Input() user: any;
    @Input() couponId : any;
    @Input() dossierId: string;

    senderForm: FormGroup;
    employerForm: FormGroup;
    employeeForm: FormGroup;

    selectedRecipient: string;
    
    needRecipientType: boolean;
    isMailSent: boolean;
    isMailPending: boolean;
    expirationDays: number = 5;

    senderTitles = [
        {label: "Madame", value: "madame", selected: false},
        {label: "Monsieur", value: "monsieur", selected: false},
        {label: "Maître", value: "maitre", selected: false},
    ];
    employerTitles = [
        {label: "Madame", value: "madame", selected: false},
        {label: "Monsieur", value: "monsieur", selected: false},
    ];
    employer_employeeTitles = [
        {label: "Madame", value: "madame", selected: false},
        {label: "Monsieur", value: "monsieur", selected: false},
    ];
    employeeTitles = [
        {label: "Madame", value: "madame", selected: false},
        {label: "Monsieur", value: "monsieur", selected: false},
    ];

    recipientTypeList = [
        {label: "Un salarié", value: "employee", selected: false},
        {label: "Un employeur que vous conseillez", value: "employer", selected: false},
    ];

    constructor(
        private formBuilder: FormBuilder,
        private cdf: ChangeDetectorRef,
        private mailService: MailService,
        private appService: AppService,
        public dialog: MatDialog,
    ){
        this.senderForm = this.formBuilder.group({
            id: ["", Validators.required],
            title: ["", Validators.required],
            names: ["", Validators.required],
            company: ["", Validators.required],
            email: [{value: "", disabled: true}, [Validators.required, Validators.email]]
        });

        this.employerForm = this.formBuilder.group({
            title: ["", Validators.required],
            firstName: ["", Validators.required],
            lastName: ["", Validators.required],
            email: ["", [Validators.required, Validators.email]],
            employeeTitle: ["", Validators.required],
            employeeFirstName: ["", Validators.required],
            employeeLastName: ["", Validators.required],
        });
        
        this.employeeForm = this.formBuilder.group({
            title: ["", Validators.required],
            firstName: ["", Validators.required],
            lastName: ["", Validators.required],
            email: ["", [Validators.required, Validators.email]],
        });
    }

    ngOnInit() : void {
        if (this.user) {
            this.senderForm.get("id").setValue(this.user.ID);
            this.senderForm.get("names").setValue(this.user.name);
            this.senderForm.get("company").setValue(this.user.firm);
            this.senderForm.get("email").setValue(this.user.email);
            if (this.user.civilite)
                this.toggleChipTitle(
                    this.senderTitles, 
                    this.getChipFromValue(this.senderTitles, this.user.civilite), 
                    "sender"
                )
        }
        if (this.dossierId) {
            this.appService.getDelegationTokenFromDossier(this.dossierId).subscribe( (response) => {
                if (response.result.token) {
                    let token = response.result.token;
                    let delegate = JSON.parse(token.delegate);
                    if (delegate.firstName) {
                        this.changeRecipient(this.recipientTypeList[1]);
                        this.toggleChipTitle(
                            this.employerTitles, 
                            this.getChipFromValue(this.employerTitles, delegate.title.toLowerCase()), 
                            "employer"
                        )
                        this.toggleChipTitle(
                            this.employer_employeeTitles, 
                            this.getChipFromValue(this.employer_employeeTitles, delegate.employeeTitle.toLowerCase()), 
                            "employer-employee"
                        )
                        this.employerForm.get("email").setValue(delegate.email);
                        this.employerForm.get("firstName").setValue(delegate.firstName);
                        this.employerForm.get("lastName").setValue(delegate.lastName);
                        this.employerForm.get("employeeFirstName").setValue(delegate.employeeFirstName);
                        this.employerForm.get("employeeLastName").setValue(delegate.employeeLastName);
                    } else if (delegate.title) {
                        this.changeRecipient(this.recipientTypeList[0]);
                        this.toggleChipTitle(
                            this.employeeTitles, 
                            this.getChipFromValue(this.employeeTitles, delegate.title.toLowerCase()), 
                            "employee"
                        );
                        this.employeeForm.get("firstName").setValue(delegate.firstName);
                        this.employeeForm.get("lastName").setValue(delegate.lastName);
                    }
                }
            })
        }
    }

    checkAndSendForm() {
        let formToCheck = null;

        switch(this.selectedRecipient) {
            case "employer":
                formToCheck = this.employerForm;
                break;
            case "employee":
                formToCheck = this.employeeForm;
                break;
            default:
                this.needRecipientType = true;
        }

        if (this.senderForm.valid && formToCheck && formToCheck.valid) {
            this.afterCheckingForm(formToCheck);
        } else {
            this.senderForm.markAllAsTouched();
            if (formToCheck)
                formToCheck.markAllAsTouched();
        }
    }

    afterCheckingForm(formToCheck) {
        if (this.dossierId) {
            this.sendEmail(formToCheck)
        } else {
            this.createDossierAndSendEmail(formToCheck);
        }
    }

    sendEmail(formToCheck) {
        this.isMailPending = true;
        let senderJson = JSON.stringify(this.senderForm.getRawValue());
        let recipientJson = JSON.stringify(formToCheck.getRawValue());
        this.mailService.sendDelegateEmail(senderJson, recipientJson, this.selectedRecipient, this.dossierId)
        .subscribe((response) => {
            if (response.success) {
                this.expirationDays = response.expirationDays;
                this.isMailSent = true;
                this.cdf.detectChanges();
            } else {
                this.dialog.open(DialogCommonError, {
                    width: '100%',
                    panelClass:'abandon-dialog',
                    data: "Votre mail n'a pas pu être envoyé, veuillez réessayer ultérieurement."
                })
            }
            this.isMailPending = false;
        })
    }

    createDossierAndSendEmail(formToCheck) {
        this.appService.createDossierDelegation(this.couponId).subscribe( (response) => {
            if (response.result.id) {
                this.dossierId = response.result.id;
                this.sendEmail(formToCheck);
            } else {
                this.dialog.open(DialogCommonError, {
                    width: '100%',
                    panelClass:'abandon-dialog',
                    data: "Votre mail n'a pas pu être envoyé, veuillez réessayer ultérieurement."
                })
            }
        })
    }

    getChipFromValue(chipList, value) {
        let result = null;
        chipList.forEach(chip => {
            if (chip.value === value) {
                result = chip;
            }
        });
        return result;
    } 

    toggleChipTitle(chipList, currentChip, form) {
        if (currentChip) {
            chipList.forEach(chip => {
                chip.selected = false;
            });
            currentChip.selected = true;
            this.setTitleValue(form, currentChip);
        }
    }

    setTitleValue(form, currentChip) {
        if (form === "sender") {
            this.senderForm.get("title").setValue(currentChip.label);
        }

        if (form === "employer") {
            this.employerForm.get("title").setValue(currentChip.label);
        }
        if (form === "employer-employee") {
            this.employerForm.get("employeeTitle").setValue(currentChip.label);
        }

        if (form === "employee") {
            this.employeeForm.get("title").setValue(currentChip.label);
        }
    }

    changeRecipient(currentRecipient) {
        this.recipientTypeList.forEach(recipient => {
            recipient.selected = false;
        });
        currentRecipient.selected = true;

        this.needRecipientType = false;
        this.selectedRecipient = currentRecipient.value;
        this.cdf.detectChanges();
    }
}